'use strict';

exports.__esModule = true;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stringify = require('../stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var style = {
  color: '#777',
  fontSize: '11px',
  padding: '4px',
  whiteSpace: 'pre',
  background: '#fff',
  overflow: 'auto'
};

exports['default'] = _createReactClass2['default']({

  displayName: 'Demo.Controls.RenderCode',

  propTypes: {
    obj: _propTypes2['default'].node.isRequired,
    indentDepth: _propTypes2['default'].number.isRequired
  },

  render: function render() {
    var _props = this.props;
    var obj = _props.obj;
    var indentDepth = _props.indentDepth;

    return _react2['default'].createElement(
      'div',
      { style: style, className: 'react-demo__render-code' },
      _stringify2['default'](obj, { depthLim: indentDepth })
    );
  }

});
module.exports = exports['default'];